module.exports = __webpack_public_path__ + "img/template-old.eab32694.png";